import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import DevelopmentClientEditPage from '../components/DevelopmentClientEditPage'
import {
  actionCreators,
  IClientEditState,
  selectCanSave,
  selectClient,
} from '../modules/clientEdit'

type IComponentState = IClientEditState & ICurrentUserState

export default withRouter(
  connect(
    createStructuredSelector<ApplicationState, IComponentState>({
      canSave: selectCanSave(),
      client: selectClient(),
      user: selectCurrentUser(),
    }),
    actionCreators,
  )(DevelopmentClientEditPage),
)
